import React, { useEffect, useState } from 'react';
import '../../../styles/components/management/steps/TaskItem.css';

const API_BASE = process.env.REACT_APP_API_BASE;

const safeJson = (str, fallback = []) => {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
};

export default function TaskItem({ task, onEdit, onDelete }) {
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      const url = `${API_BASE}/app/API/rbmgt/task_details.php?task_id=${task.TASK_TEMPLATE_ID}`;
      try {
        console.debug('📡 Fetching task details:', url);
        const res = await fetch(url);
        const data = await res.json();
        console.debug('✅ Task details response:', data);
        if (data.success) setDetails(data.details);
      } catch (err) {
        console.error('❌ Failed to fetch task details:', err);
      }
    };
    fetchDetails();
  }, [task.TASK_TEMPLATE_ID]);

  return (
    <div className="task-item-admin">
      <div className="task-header">
        <span className="task-name">{task.TASK_NAME}</span>
        <div>
          <button className="task-btn edit" onClick={onEdit} aria-label="Edit Task">✏️</button>
          <button className="task-btn delete" onClick={onDelete} aria-label="Delete Task">🗑️</button>
        </div>
      </div>

      <div className="task-desc">{task.DESCRIPTION}</div>
      <div className="task-kind">
        Kind: <strong>{task.TASK_KIND}</strong>
      </div>

      {details && (
        <div className="task-meta">

          {/* Media preview */}
          {details.EXAMPLE_MEDIA && (
            details.EXAMPLE_MEDIA.match(/\.(jpe?g|png|gif)$/i) ? (
              <img src={details.EXAMPLE_MEDIA} alt="Example" className="meta-media" />
            ) : (
              <video controls className="meta-media">
                <source src={details.EXAMPLE_MEDIA} />
                Your browser does not support the video tag.
              </video>
            )
          )}

          {/* Example text */}
          {details.EXAMPLE_TEXT?.trim() && (
            <div className="meta-section">
              <strong>Example Text:</strong> {details.EXAMPLE_TEXT}
            </div>
          )}

          {/* Options */}
          {details.OPTIONS && safeJson(details.OPTIONS).length > 0 && (
            <div className="meta-section">
              <strong>Options:</strong>
              <ul>
                {safeJson(details.OPTIONS).map((opt, i) => (
                  <li key={i}>{opt}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Inventory */}
          {details.INVENTORY_ITEMS && safeJson(details.INVENTORY_ITEMS).length > 0 && (
            <div className="meta-section">
              <strong>Inventory:</strong>
              <ul>
                {safeJson(details.INVENTORY_ITEMS).map((it, i) => (
                  <li key={i}>
                    {it.name} — {it.value} {it.type}
                  </li>
                ))}
              </ul>
            </div>
          )}

        </div>
      )}
    </div>
  );
}
